import { useQuery } from "@tanstack/react-query";
import { Entry } from "../models/Entry";
import { getEntries } from "../repository/LogbookRepository";

type UseEntriesProps = {
	shiftId?: number;
	assetId?: number | null;
};

export const useEntries = ({ shiftId, assetId }: UseEntriesProps) => {
	return useQuery<Entry[], Error>({
		queryKey: ["entries", shiftId, assetId],
		queryFn: ({ signal }) => getEntries({ shiftId, assetId, signal }),
		enabled: shiftId != null,
	});
};

export const routeLogbookEntry = "/logbook/entry";
